var render, staticRenderFns
import script from "./CustomDocumentsAtas.vue?vue&type=script&lang=js"
export * from "./CustomDocumentsAtas.vue?vue&type=script&lang=js"
import style0 from "./CustomDocumentsAtas.vue?vue&type=style&index=0&id=6b53baaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53baaa",
  null
  
)

export default component.exports